import store from 'src/store';

class ErrorHandler {
	static updateBreakingErrors(errors) {
		store.dispatch({ type: 'UPDATE_BREAKING_ERRORS', payload: { errors } });
	}
}

export default ErrorHandler;
